import CollapsibleSection from '@/global/components/CollapsibleSection'
import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import {
    SelectCentroCusto,
    SelectFuncionarios as SelectComp,
    SelectEmpresa,
    SelectLocais,
} from '@/global/components/Selects'
import { SimpleTabs } from '@/global/components/Tabs'
import Grid from '@/global/components/ui/Grid'
import { useAuth } from '@/hooks'
import { useStore } from '@/store'
import { CategoriaEnum } from '@acme/auth/roles'

type Props = {
    /** Funcionários já vinculados — aparecem marcados e desabilitados */
    checked?: number[]
    /**
     * Torna o divisor "Funcionários" um gatilho de expandir/retrair. Começa
     * retraído quando já existe funcionário pré-selecionado.
     */
    collapsible?: boolean
    /** Renderiza o seletor de empresa acima das abas. */
    selectEmpresa?: boolean
} & (
    | {
          funcionarioIds: number[]
          onChange: (ids: number[]) => void
          formName?: never
      }
    | {
          funcionarioIds?: never
          onChange?: never
          formName: string
      }
)

export default function TabFuncionariosForm(props: Props) {
    const {
        decoded: { categoria },
    } = useAuth()
    const setCentroCustoId = useStore(state => state.setCostCenterId)
    const setLocais = useStore(state => state.setLocaisIds)

    if (categoria === CategoriaEnum.Funcionario) {
        return null
    }

    const tabs = (
        <>
            {props.selectEmpresa && <SelectEmpresa variant="form" />}
            <SimpleTabs
                onChange={() => {
                    setCentroCustoId(-1)
                    setLocais([])
                }}
                className="mb-4"
                tabs={[
                    {
                        value: 'nao-filtrar',
                        label: 'Todos',
                        content: (
                            <BoxSelects>
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                    {
                        value: 'centro-custo',
                        label: 'Por centro de custo',
                        content: (
                            <BoxSelects>
                                <SelectCentroCusto
                                    width="100%"
                                    key="centro-custo"
                                    size="medium"
                                />
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                    {
                        value: 'local',
                        label: 'Por local',
                        content: (
                            <BoxSelects>
                                <SelectLocais
                                    width="100%"
                                    key="locais"
                                    size="medium"
                                />
                                <CompSelect {...props} />
                            </BoxSelects>
                        ),
                    },
                ]}
            />
        </>
    )

    return (
        <Grid item xs={12} key="funcionarios">
            {props.collapsible ? (
                <CollapsibleSection
                    title="Funcionários"
                    defaultOpen={!props.funcionarioIds?.length}
                >
                    {tabs}
                </CollapsibleSection>
            ) : (
                <>
                    <HorizontalDivider className="my-4 select-none">
                        Funcionários
                    </HorizontalDivider>
                    {tabs}
                </>
            )}
        </Grid>
    )
}

function CompSelect(props: Props) {
    return (
        <SelectComp
            key="funcionarios"
            defaultValues={props.funcionarioIds}
            onChange={props.onChange}
            form={props.formName}
            checked={props.checked}
            helperText=" "
            width="100%"
            size="medium"
            useFilter
        />
    )
}

function BoxSelects({ children }: { children: React.ReactNode }) {
    return <div className="flex size-full gap-4 pt-4 flex-col">{children}</div>
}
